module.exports = __webpack_public_path__ + "d0085eae44a7795384d00c5562834b11.svg";